// byLoren: când clienta alege o mărime în filtre, bifăm automat „În stoc”,
// ca să vadă doar modelele pe care le poate cumpăra în mărimea ei.
// Dacă debifează „În stoc”, nu o mai bifăm din nou în sesiunea curentă.
(() => {
  const SIZE_FILTER = /^filter\.v\.option\.(marime|mărime|marimi|size)$/i;
  const AVAILABILITY = 'filter.v.availability';
  const OPT_OUT_KEY = 'byloren:instock-off';

  const optedOut = () => {
    try {
      return sessionStorage.getItem(OPT_OUT_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  const setOptOut = (off) => {
    try {
      if (off) sessionStorage.setItem(OPT_OUT_KEY, '1');
      else sessionStorage.removeItem(OPT_OUT_KEY);
    } catch (e) {}
  };

  const hasSize = (params) => Array.from(params.keys()).some((key) => SIZE_FILTER.test(key));

  // Capture phase: runs before facet-form builds its URL from the form data.
  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox') return;
      const form = input.closest('form[is="facet-form"]');
      if (!form) return;

      if (input.name === AVAILABILITY) {
        if (input.value === '1') setOptOut(!input.checked);
        return;
      }

      if (!SIZE_FILTER.test(input.name) || !input.checked || optedOut()) return;
      if (form.querySelector(`input[name="${AVAILABILITY}"]:checked`)) return;

      const inStock = form.querySelector(`input[name="${AVAILABILITY}"][value="1"]`);
      if (inStock && !inStock.disabled) inStock.checked = true;
    },
    true
  );

  // Removing the „În stoc” tag from the active filters counts as opting out too.
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest && event.target.closest('a[is="facet-remove"]');
      if (!link) return;
      const current = new URL(window.location.href).searchParams;
      const next = new URL(link.href, window.location.href).searchParams;
      if (current.get(AVAILABILITY) === '1' && next.get(AVAILABILITY) !== '1' && hasSize(next)) setOptOut(true);
    },
    true
  );
})();
